<template>
  <div>
    <b-table
      :id="id"
      ref="reportListTableRef"
      :bordered="true"
      :items="listReport"
      :fields="reportFields"
      class="table-striped mt-1"
      :primary-key="'id'"
      role="grid"
      aria-describedby="user-list-page-info"
    >
      <template v-slot:cell(stt)="data">
        <span>{{data.item.stt}}</span>
      </template>
      <template v-slot:cell(title)="data">
        <div class="flex align-items-center">
          <span v-html="data.item.space"/>
          <span class="ml-2">{{ data.item.title }}</span>
        </div>
      </template>
      <template v-slot:cell(vnd)="data">
        <span :style="applyNumberStyle(data.item.total_vnd)">{{data.item.total_vnd}}</span>
      </template>

      <template v-slot:cell(usd)="data">
        <span :style="applyNumberStyle(data.item.total_usd)">{{data.item.total_usd}}</span>
      </template>
      <template v-slot:cell(action)="data">
                  <div class="flex align-items-center list-user-action">
                    <a
                      class="iq-bg-primary"
                      data-toggle="tooltip"
                      data-placement="top"
                      title
                      data-original-title="Xóa"
                      @click="confirmDelete(data.item.id)"
                    >
                      <i class="las la-trash-alt text-red"></i>
                    </a>
                  </div>
                </template>

      <template v-slot:custom-foot>
        <tr>
          <td></td>
          <td align="right">TỔNG</td>
          <td align="right" v-if="detailReport.summary_success_report" :style="applyNumberStyle(detailReport.summary_success_report['payment']['vnd'])">{{applyNumberFormat(detailReport.summary_success_report['payment']['vnd'],'th')}}</td>
          <td align="right" v-if="detailReport.summary_success_report" :style="applyNumberStyle(detailReport.summary_success_report['payment']['usd'])">{{applyNumberFormat(detailReport.summary_success_report['payment']['usd'],'en')}}</td>
        </tr>
      </template>
    </b-table>
  </div>
</template>

<script>
import { findash } from '../../../../config/pluginInit'
import _ from 'lodash'
import { applyNumberStyle, formatNumber, formatNumberByLocale } from '@/utils'
import { mapActions, mapGetters } from 'vuex'
import api from '@/store/api'

function isEmptyData (ele) {
  return (ele.total_vnd === '0' && ele.total_usd === '0') || (ele.total_vnd === 0 && ele.total_usd === 0)
}

export default {
  name: 'Payment',
  async mounted () {
    findash.index()
  },
  created () {
  },
  props: [ 'id' ],
  data () {
    return {
      reportFields: [
        {
          key: 'stt',
          label: '#',
          class: 'text-center'
        },
        {
          key: 'title',
          label: 'THÀNH VIÊN',
          class: 'text-left'
        },
        {
          key: 'vnd',
          label: 'VND',
          class: 'text-right',
          thStyle: { width: '150px' }
        },
        {
          key: 'usd',
          label: 'USD',
          class: 'text-right',
          thStyle: { width: '150px' }
        },
        {
          key: 'action',
          label: '',
          class: 'text-center',
          thStyle: { width: '50px' }
        }
      ],
      listReport: [],
      stt: 1,
      custom_id: 0,
      parseDataArr: null
    }
  },
  computed: {
    ...mapGetters({
      'detailReport': 'Report/detailReportState'
    })
  },
  watch: {
    detailReport: function (newVal, oldVal) {
      if (newVal !== oldVal && this.detailReport.payments) {
        this.parseData()
      }
    }
  },
  methods: {
    ...mapActions({
      'loadDetailReport': 'Report/loadDetailReport'
    }),
    skeletorData (data, rootLevel) {
      _.map(data, (e) => {
        let _stt = ''

        if (rootLevel) {
          _stt = this.stt++
        }

        return _.extend(e, { custom_id: this.custom_id++, toggle: false, space: '', level: 1, stt: _stt })
      })

      return data
    },
    applyNumberStyle (number) {
      return applyNumberStyle(number)
    },
    applyNumberFormat (number, locale) {
      return formatNumberByLocale(number, locale)
    },
    parseData () {
      let parseDataReturn = null

      parseDataReturn = _.compact(_.map(this.detailReport.payments, (level0) => {
        if (isEmptyData(level0)) return
        if (level0.type !== 'payment') return
        return {
          'id': level0.id,
          'title': level0.member_name,
          'total_vnd': formatNumber(level0.amount_vnd),
          'total_usd': formatNumber(level0.amount_usd)
        }
      }))

      let sortedPayment = _.orderBy(parseDataReturn, (e) => {
        return e.title
      })

      this.listReport = this.skeletorData(sortedPayment, true)

      // reset
      this.stt = 1
    },
    confirmDelete (id) {
      this.$swal({
        title: 'Giao dịch',
        text: 'Bạn chắc chắn xóa giao dịch này ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Xóa',
        denyButtonText: `Hủy`
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          api.transaction.delete(id).then(async () => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })

            await this.loadDetailReport(this.detailReport.selected_report_id)
            this.parseData()
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            })
          })
        } else if (result.isDenied) {

        }
      }).catch(() => {
      })
    }
  }
}
</script>
